<template>
  <v-card>
    <v-flex
      xs12
      md4
      offset-md8
      class="pa-3">
      <v-text-field
        :label="$t('searchArchive')"
        v-model="search"
        append-icon="search"
      />
    </v-flex>
    <v-data-table
      :rows-per-page-items="[15, 25, 50]"
      :loading="isLoading"
      :items="archives"
      :headers="headers"
      :pagination.sync="pagination"
      :total-items="paginationTotal"
      class="text-xs-left"
      must-sort
    >
      <template
        slot="items"
        slot-scope="props">
        <tr :key="props.index">
          <td>
            {{ props.item.month }}
          </td>
          <td>
            {{ props.item.number_of_timesheets }}
          </td>
          <td>
            {{ props.item.last_updated_timestamp }}
          </td>
          <td align="right">
            <ArchivesDownload :item="props.item"/>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import PaginationApi from '@/api/PaginationApi'
import syncDataWithLocalStorageMixin from '@/mixins/syncDataWithLocalStorageMixin'
import debounce from 'lodash/debounce'

import ArchivesDownload from './ArchivesDownload'

export default {
  name: 'ArchivesOverview',
  components: { ArchivesDownload },
  mixins: [syncDataWithLocalStorageMixin],
  data: function () {
    return {
      search: null,
      isLoading: false,
      errorMessages: {},
      archives: [],
      pagination: {},
      paginationTotal: null,
      url: 'company/archives',
      headers: [
        {
          text: this.$t('month'),
          value: 'month',
          align: 'left',
          index: '0',
          sortable: true
        },
        {
          text: this.$t('number_of_timesheets'),
          value: 'number_of_timesheets',
          align: 'left',
          index: '0',
          sortable: true
        },
        {
          text: this.$t('last_updated_timestamp'),
          value: 'last_updated_timestamp',
          align: 'left',
          index: '0',
          sortable: true
        },
        {
          text: '',
          value: 'actions',
          align: 'right',
          index: '0',
          sortable: false
        }
      ]
    }
  },
  methods: {
    searchArchive: debounce(async function (e) {
      if (e === '') {
        this.getArchives()
      }

      if (e && e.length) {
        this.getArchives()
      }
    }, 250),
    async getArchives () {
      this.isLoading = true
      try {
        const paginationParams = []
        const query = {}

        if (this.search) {
          paginationParams.push(`search=${this.search}`)
          query.search = this.search
        }

        paginationParams.push(`page=${this.pagination.page}`)
        query.page = this.pagination.page

        paginationParams.push(`rowsPerPage=${this.pagination.rowsPerPage}`)
        query.rowsPerPage = this.pagination.rowsPerPage

        paginationParams.push(
          `sortBy=${this.pagination.sortBy}`,
          `descending=${this.pagination.descending}`
        )
        query.sortBy = this.pagination.sortBy
        query.descending = this.pagination.descending

        this.$router.push({ name: this.$route.name, query })
        const response = await PaginationApi.getPaginatedData(
          this.url,
          paginationParams
        )

        this.paginationTotal = response.total
        this.archives = response.data

        const { sortBy, rowsPerPage, descending } = query
        this.$storeData({ sortBy, rowsPerPage, descending })
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler: 'getArchives'
    },
    search: 'searchArchive'
  },
  created () {
    if (this.$route.query) {
      const userId = this.$store.state.user.userInfo.id
      this.localStorageSyncConfigKey = `elsazeit.config.${userId}.archivesOverview`
      this.$loadData()

      if (!this.$syncDataToLocalStorage) this.$storeData(this.$route.query)
      const { sortBy, rowsPerPage, descending } = this.$syncDataToLocalStorage
      const { search, page } = this.$route.query
      this.search = search
      this.pagination.sortBy = sortBy || 'month'
      this.pagination.descending = String(descending) === 'true'
      this.pagination.page = Number(page) || 1
      this.pagination.rowsPerPage = Number(rowsPerPage) || 15
    }
  },
  i18n: {
    messages: {
      en: {
        month: 'Month',
        number_of_timesheets: 'Timesheets count',
        last_updated_timestamp: 'Last updated timesheet',
        searchArchive: 'Archives search...'
      },
      tr: {
        month: 'Ay',
        number_of_timesheets: 'Zaman çizelgeleri sayılır',
        last_updated_timestamp: 'Son güncellenen zaman çizelgesi',
        searchArchive: 'Arşiv araması ...'
      },
      de: {
        month: 'Monat',
        number_of_timesheets: 'Anzahl Stundenzettel',
        last_updated_timestamp: 'Letzte Aktualisierung',
        searchArchive: 'Durchsuchen'
      },
      ru: {
        month: 'Месяц',
        number_of_timesheets: 'Кол-во табелей',
        last_updated_timestamp: 'Последнее изменение',
        searchArchive: 'Поиск архивов...'
      }
    }
  }
}
</script>
